module.exports = __webpack_public_path__ + "static/media/ruffles-crunch-teen-burger-mb-en.c1e54df2.jpg";